export const MIN_CIRCLE_RADIUS = 8;
export const DEFAULT_CIRCLE_RADIUS = MIN_CIRCLE_RADIUS;
export const MAX_CIRCLE_RADIUS = MIN_CIRCLE_RADIUS + 15;
